﻿import { fetchRequest } from '@tk/utilities/tk.fetch';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import KDMZLoadingAnimation from '@/components/KDMZ.loading.animation';

export default class KDMZFileUploadArea extends TKFileUploadArea {
    reloadAfterSuccess: boolean;
    reloadAfterSuccessAsyncContent?: HTMLElement;

    constructor() {
        super();

        this.reloadAfterSuccess = !!(
            this.hasAttribute('data-kdmz-reload-after-success') &&
            this.getAttribute('data-kdmz-reload-after-success') === 'true'
        );
        this.reloadAfterSuccessAsyncContent =
            document.querySelector('[data-kdmz-reload-after-success-async-content]') || undefined;
    }

    // overwritten from mother class
    async getResponseData(xhr: XMLHttpRequest): Promise<{ url: string }> {
        if (xhr instanceof XMLHttpRequest && xhr.status === 200) {
            const response = await this.moveFile();
            const { path, success } = response.dataAsJson;
            if (!success) {
                const error = { name: 'CANCEL', message: 'FAILED!' };
                this.uppy?.emit('error', error);
                this.uppy?.emit('cancel-all');
                return { url: '' };
            } else {
                if (this.isWithinIFrame) {
                    window.parent.postMessage(
                        {
                            mceAction: 'close',
                            content: path,
                            size: {
                                width: 0,
                                height: 0,
                            },
                        },
                        '*',
                    );
                } else if (this.reloadAfterSuccess) {
                    KDMZLoadingAnimation.createLoadingScreen();

                    if (this.reloadAfterSuccessAsyncContent) {
                        const asyncUrl = window.location.href;
                        fetchRequest({
                            requestURL: asyncUrl!,
                            resolveHandler: this.setResponseData.bind(this),
                        });
                    } else {
                        window.location.reload();
                    }
                }
                return {
                    url: path || '',
                };
            }
        }
        return { url: '' };
    }

    setResponseData(response: TKResponse) {
        KDMZLoadingAnimation.destroyLoadingScreen();
        if (this.reloadAfterSuccessAsyncContent) {
            const div = document.createElement('div');
            div.innerHTML = response.dataAsHtml;
            const list = div.querySelector('.printorder-documents');
            if (list) this.reloadAfterSuccessAsyncContent.innerHTML = list.innerHTML;
        } else {
            window.location.reload();
        }
    }
}
